import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'compactNumberValues',
  standalone: true
})
export class CompactNumberValuesPipe implements PipeTransform {
  private static readonly THRESHOLDS = [
    { value: 1e15, symbol: 'Q' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' },
    { value: 1, symbol: '' }
  ];

  transform(value: number | string | null | undefined): string {
    if (value == null) {
      return '';
    }

    const num = Number(value.toString().replace(/,/g, ''));

    if (isNaN(num)) {
      return value.toString();
    }

    if (num === 0) {
      return '0';
    }

    const threshold = CompactNumberValuesPipe.THRESHOLDS.find(
      t => Math.abs(num) >= t.value
    );

    if (!threshold) {
      return num.toString();
    }

    const scaled = num / threshold.value;
    const formatted = Number.isInteger(scaled) ? scaled.toString() : scaled.toFixed(1);

    return `${formatted}${threshold.symbol}`;
  }
}
